import axios from "axios";
import summaryApi from "../common/Api";

const fetchCategoryProduct = async (category) => {
  try {
    if (!category) {
      return [];
    }

    const response = await axios.post(summaryApi.categoryWiseProduct.url, {
      category: category,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching category products:", error);
    return [];
  }
};

export default fetchCategoryProduct;
